/**
 * 印表機缺紙橫幅 — Flow 4.1 / kiosk-screens E2-printer-empty。
 *
 * 缺紙時：頂部出現 HW-004 警示橫幅；TicketDelivery 之紙本 QR 選項
 * 透過 `useIsPrinterPaperOut` 自動 disabled。補紙事件即時恢復。
 */

import { useEffect, useState } from 'react';

import { HW_004, isPrinterPaperOut, PRINTER_STATUS_EVENT } from '../lib/printer';
import { useKiosk } from '../lib/session';

/** 共用 hook：監聽 URL / storage / 廣播事件之印表機狀態。 */
export function useIsPrinterPaperOut(): boolean {
  const [paperOut, setPaperOut] = useState<boolean>(() => isPrinterPaperOut());
  useEffect(() => {
    const sync = (): void => setPaperOut(isPrinterPaperOut());
    window.addEventListener(PRINTER_STATUS_EVENT, sync);
    window.addEventListener('storage', sync);
    sync();
    return () => {
      window.removeEventListener(PRINTER_STATUS_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);
  return paperOut;
}

export function PrinterBanner(): JSX.Element | null {
  const paperOut = useIsPrinterPaperOut();
  const { locale } = useKiosk();
  if (!paperOut) return null;
  const lang = locale === 'zh-TW' ? 'zh-TW' : locale === 'en' ? 'en' : 'ja';
  return (
    <div
      role="status"
      data-testid="kiosk-printer-banner"
      data-error-code={HW_004.code}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9998,
        background: '#b8860b',
        color: '#fff',
        padding: '14px 24px',
        textAlign: 'center',
        fontSize: 'var(--fs-body)',
        fontWeight: 600,
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      }}
    >
      🖨 {HW_004.message[lang]}（{HW_004.code}）
      <div style={{ fontWeight: 400, fontSize: 'var(--fs-small)', marginTop: 4 }}>
        {HW_004.suggestion[lang]}
      </div>
    </div>
  );
}
